import React, { Component, Fragment } from 'react';
import OtpInput from 'react-otp-input';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';

import TextField from '../../artzu-ui/src/TextField';
import MobileSendModal from './MobileSendModal';
import ConfirmationModal from './ConfirmationModal';

import Header from '../NewProfile/Header';

import ScrollLock from 'react-scrolllock';

import './smsVerification.css';
import { editDashes } from '../NewContact/NewContactForm';

class SmsVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      resend: '',
      mobile: '',
      newMobile: '',
      resendClicked: false,
      error: false,
      mobileModalOpen: false,
      confirmationModalOpen: false,
      disabled: false,
      mobileError: false
    };
  }

  componentDidMount() {
    this.checkVerified();
  }

  closeMobileModal = () => this.setState({ mobileModalOpen: false });

  openConfirmationModal = () =>
    this.setState({ confirmationModalOpen: true });

  checkVerified = async () => {
    const { client, history } = this.props;
    const { data } = await client.query({
      query: CHECK_VERIFICATION
    });
    if (data.currentUser.smsVerified) {
      history.push('/dashboard');
    }
    const mobile = await data.currentUser.mobile;
    this.setState({ mobile, newMobile: mobile });
  };

  handleChange = token =>
    this.setState({ token }, () => this.afterChange(token));
  handleError = error => this.setState({ error });

  afterChange = async token => {
    await this.handleError(false);
    await this.setState({ resend: '' });
    if (token.length === 6) this.handleSubmit();
  };

  handleSubmit = async () => {
    const { token } = this.state;
    const { client, refetchVerification } = this.props;
    const { data } = await client.query({
      query: VERIFY,
      variables: { token }
    });
    if (data.verifySms) {
      refetchVerification();
      this.openConfirmationModal();
      document.getElementById('confirmation-modal').focus();
      document.getElementById('verify_form').blur();
      this.setState({ disabled: true });
    } else {
      await this.handleError(true);
    }
  };

  handleResendClicked = () =>
    this.setState({ resendClicked: !this.state.resendClicked });

  handleMobileChange = e =>
    e.target.value.length > 12
      ? null
      : this.setState({ newMobile: e.target.value });

  resendCode = async () => {
    const { newMobile } = this.state;
    const { data } = await this.props.client.query({
      query: RESEND_CODE,
      variables: { mobile: newMobile }
    });
    if (data.resendSmsVerification) {
      this.setState({
        resend: 'Please check your phone for a new code.',
        mobile: newMobile,
        resendClicked: true,
        mobileModalOpen: true,
        mobileError: false
      });
    } else {
      this.setState({
        mobile: newMobile,
        resendClicked: true,
        mobileError: true
      });
    }
  };

  render() {
    const {
      error,
      newMobile,
      resendClicked,
      mobileModalOpen,
      confirmationModalOpen,
      disabled,
      mobileError
    } = this.state;
    return (
      <Fragment>
        <Header title="Mobile Phone" />
        <MobileSendModal
          open={mobileModalOpen}
          closeModal={this.closeMobileModal}
        />
        <ConfirmationModal
          location={this.props.location}
          open={confirmationModalOpen}
          history={this.props.history}
        />
        <ScrollLock>
          <div className="container verify_container">
            <div className="verify_panel">
              <div className="verify_panel_inner">
                <div className="verify_text">
                  <p>
                    Please enter the 6-digit verification code we sent to
                    your mobile phone.
                  </p>
                </div>
                <div className="verify_resend--content">
                  <div className="verify_resend_container">
                    <TextField
                      width="100%"
                      heading="Phone Number"
                      value={editDashes(newMobile)}
                      onChange={this.handleMobileChange}
                      error={mobileError ? 'Mobile has been taken.' : null}
                    />
                    <button
                      className="verify_button"
                      onClick={e => {
                        e.preventDefault();
                        this.resendCode();
                      }}>
                      {resendClicked ? 'Resend' : 'Send'}
                    </button>
                  </div>
                  {disabled ? null : (
                    <div className="verify_form--container">
                      <div className="verify_form--title">
                        Verification Code
                      </div>
                      <form
                        id="verify_form"
                        className="verify_form"
                        onSubmit={e => {
                          e.preventDefault();
                          this.handleSubmit();
                        }}>
                        <OtpInput
                          onChange={this.handleChange}
                          numInputs={6}
                          hasErrored={error}
                          errorStyle={{
                            outline: 'none',
                            border: 'none',
                            borderBottom: '3px solid tomato',
                            borderRadius: '0',
                            transitionDuration: '0.25s'
                          }}
                          inputStyle={{
                            outline: 'none',
                            border: 'none',
                            borderBottom: '2px solid #DEDEDE',
                            borderRadius: '0'
                          }}
                          focusStyle={{
                            outline: 'none',
                            border: 'none',
                            borderBottom: '3px solid black',
                            borderRadius: '0'
                          }}
                          containerStyle={{
                            justifyContent: 'space-between',
                            width: '100%'
                          }}
                        />
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ScrollLock>
      </Fragment>
    );
  }
}

export default withApollo(SmsVerification);

const VERIFY = gql`
  query verifySms($token: String!) {
    verifySms(token: $token)
  }
`;

const CHECK_VERIFICATION = gql`
  {
    currentUser {
      id
      smsVerified
      mobile
    }
  }
`;

const RESEND_CODE = gql`
  query resendSmsVerification($mobile: String!) {
    resendSmsVerification(mobile: $mobile)
  }
`;



// WEBPACK FOOTER //
// ./src/components/User/SmsVerification.js